import { Api } from 'old-store/utils';
import { PhotobookGroupEnum } from 'constants/photobooks';
import { setCoverImage, setLastUpdate, updateSpreads, PhotobookUpdateType } from '.';

export const isCoverImagePhotobook = (products: any, productId: string): boolean => {
  const currentGroup = products.groups.find((p) => p._id === PhotobookGroupEnum.PhotobookSbe);
  const product = currentGroup?.products?.find((prod) => prod._id === productId);

  return product?._productGroup === PhotobookGroupEnum.PhotobookSbe;
};

export const createBoundsRelative = (
  xPercent: number,
  yPercent: number,
  widthPercent: number,
  heightPercent: number
) => ({
  widthPercent,
  heightPercent,
  leftPercent: xPercent,
  topPercent: yPercent
});

export const updateCoverImagePosition = async (
  photobookId: string,
  coverImageId: string,
  xPercent: number,
  yPercent: number,
  widthPercent: number,
  heightPercent: number,
  dispatch: any
) => {
  const coverImage = {
    id: coverImageId,
    frameIndex: 0,
    boundsRelative: createBoundsRelative(xPercent, yPercent, widthPercent, heightPercent)
  };

  dispatch(setCoverImage({ photobookId, coverImage }));

  const { result, timestamp } = await Api.Photobook.updateCoverImage(photobookId, {
    coverImage
  });

  dispatch(setLastUpdate(timestamp));

  return result;
};

export const updateSpreadImagePosition = async (
  photobookId: string,
  title: string,
  slug: string,
  spreads: any[],
  currentSpreadIdx: number,
  frameIndex: number,
  xPercent: number,
  yPercent: number,
  widthPercent: number,
  heightPercent: number,
  dispatch: any
) => {
  const currentSpread = spreads[currentSpreadIdx];
  const currentImage = currentSpread.images.find((image) => image.frameIndex === frameIndex);

  currentImage.boundsRelative = createBoundsRelative(
    xPercent,
    yPercent,
    widthPercent,
    heightPercent
  );

  dispatch(updateSpreads({ photobookId, spreads }));

  const { result, timestamp } = await Api.Photobook.updatePhotobookSpreads(
    photobookId,
    title,
    slug,
    spreads,
    PhotobookUpdateType.UpdateImageCropping
  );

  dispatch(setLastUpdate(timestamp));

  return result;
};
